import React from 'react';
import Modal from './Modal';

const ReceiptModal = ({ isOpen, onClose, url, title, onDelete }) => {
  if (!isOpen) return null;

  const isPdf = /\.pdf(\?|$)/i.test(url);
  const isHeic = /\.(heic|heif)(\?|$)/i.test(url);

  return (
    <Modal isOpen={true} onClose={onClose} title={title} width={1200}>
      <div style={{ width: '90vw', maxWidth: 1200, height: '80vh', maxHeight: '80vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: '1 1 auto', minHeight: 0, overflow: 'auto', padding: 16 }}>
          {isPdf ? (
            <div style={{ height: '70vh', maxHeight: '70vh' }}>
              <iframe
                title="Receipt PDF"
                src={url}
                style={{ width: '100%', height: '100%', border: 'none' }}
              />
            </div>
          ) : isHeic ? (
            <div>
              <p style={{ marginBottom: 8 }}>This receipt is in HEIC/HEIF format, which most browsers cannot display inline. You can open or download it using the link below:</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <a href={url} target="_blank" rel="noreferrer">Open receipt file</a>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                alt="Receipt"
                src={url}
                style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
              />
            </div>
          )}
        </div>
        <div style={{ flex: '0 0 auto', padding: '8px 16px', borderTop: '1px solid #374151', display: 'flex', justifyContent: 'flex-start', gap: 8 }}>
          <button className="btn btn-outline-danger btn-sm" onClick={onDelete}>
            Delete Receipt
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ReceiptModal;
